import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export default function CatalogFallbackBanner({ isMenuPublicApiFallback, onRefresh }) {
  const { t } = useTranslation();
  return (
    <div
      className="border-b border-amber-200 bg-amber-50 text-amber-950 px-4 py-3"
      role="status"
      data-testid="menu-fallback-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="space-y-1">
          <p className="font-semibold text-sm sm:text-base">
            {isMenuPublicApiFallback ? t('catalog.fallbackAvailable') : t('catalog.fallbackEmergency')}
          </p>
          <p className="text-xs sm:text-sm text-amber-900/90">
            {t('catalog.ordersPaused')}
          </p>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="shrink-0 border-amber-300 bg-white hover:bg-amber-100 text-amber-950"
          onClick={onRefresh}
          data-testid="menu-refresh-from-api"
        >
          {t('catalog.refreshMenu')}
        </Button>
      </div>
    </div>
  );
}
